module.exports = __webpack_public_path__ + "img/space.c38c1167.svg";